import React, { useEffect, useState } from 'react';
import WeekComparisonViolinChart from './WeekComparisonViolinChart';

// Fetches pressure readings and renders week comparison violins
function CyclonePressureChart({ start, end, isCustom = false }) {
  const [rows, setRows] = useState([]);

  useEffect(() => {
    if (!start || !end) return;
    const toDateStr = d => {
      const tzOffset = d.getTimezoneOffset() * 60000;
      return new Date(d.getTime() - tzOffset).toISOString().slice(0, 10);
    };
    const startDate = new Date(start);
    let params;
    if (isCustom) {
      params = `?start=${encodeURIComponent(start)}&end=${encodeURIComponent(end)}`;
    } else {
      const prevStart = new Date(startDate.getTime() - 7 * 24 * 60 * 60 * 1000);
      const prevStartStr = toDateStr(prevStart);
      params = `?start=${encodeURIComponent(prevStartStr)}&end=${encodeURIComponent(end)}`;
    }
    fetch(`/api/cyclone-pressures.php${params}`)
      .then(res => res.json())
      .then(setRows)
      .catch(() => setRows([]));
  }, [start, end, isCustom]);

  const startMs = start ? new Date(start).getTime() : 0;
  const currentWeek = rows.filter(r => new Date(r.timestamp).getTime() >= startMs);
  const previousWeek = isCustom
    ? []
    : rows.filter(r => new Date(r.timestamp).getTime() < startMs);

  return (
    <div className="flex-1 relative" style={{ height: '160px' }}>
      <WeekComparisonViolinChart
        current={currentWeek}
        previous={previousWeek}
        customLabel={isCustom ? 'Custom date' : undefined}
      />
    </div>
  );
}

export default CyclonePressureChart;
